import { baseUrl } from "../../../utils/apiData";
import "./SolutionSecondSec.scss";

const SolutionSecondSec = ({ infoData, title, iconList }) => {
  return (
    <section className="solution_second_sec">
      <div className="content_wrap p_top p_bottom">
        <h2 className="wow fadeInUp">{title}</h2>

        <div className="bigrid_info">
          {infoData?.map((item, i) => {
            return (
              <div
                className="info_line wow fadeInUp"
                key={i}
                data-wow-delay={`${(i % 2) * 0.1}s`}
              >
               <img src={`${baseUrl}/${iconList[i]}`} alt="Icon" />
                <p>{item}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SolutionSecondSec;
